import { ReactNode } from "react";
import { Link } from "../../link";

interface ActionButtonGroupProps {
  children?: ReactNode;
}

export const ActionButtonGroup = ({
  children,
}: ActionButtonGroupProps): JSX.Element => {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex gap-2.5 lg:gap-8">{children}</div>
    </div>
  );
};

interface ActionButtonProps {
  href: string;
  ["data-cy"]?: string;
  children?: ReactNode;
}
export const ActionButton = ({
  href,
  "data-cy": dataCy,
  children,
}: ActionButtonProps): JSX.Element => {
  return (
    <Link
      data-cy={dataCy}
      href={href}
      variant="action"
      size="small"
      className="w-fit"
    >
      {children}
    </Link>
  );
};
